import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import getLocale from '../../i18n/getLocale';
import Overlay from '../Miscelania/Overlay';

class FuelSupplierLocationsEdit extends Component {

    constructor(props) {
        super(props);

        this.state = {
        overlay: {
            message: '',
            type: '',
            status: 'open',
        },
        redirect_url: false,
        loaded: 0,
        fuel_locations: {},
        };
        //Handlers
        this.handleAlert = this.handleAlert.bind(this);
        this.handleLoaded = this.handleLoaded.bind(this);
        this.handleMessage = this.handleMessage.bind(this);
        this.locale = getLocale();

        this.loadData = this.loadData.bind(this);
        this.edit = this.edit.bind(this);
    }
    // Handlers

    handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
        var value = 1;
        } else {
        var value = 0;
        }
        change[name] = value;
        this.setState(change);
    }


    handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
    }
    handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
        change[name] = null;
        } else {
        change[name] = event.value;
        }
        this.setState(change);
    }
    handleAlert(message, type, status, mode) {
        if(mode === 'reset') {
        this.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
        this.setState({overlay: {message: message, type: type, status: status}});
        }
    }

    handleLoaded(state) {
        if(this.state.loaded !== 2) {
        this.setState({loaded: state});
        }
    }

    handleMessage () {
        var message = localStorage.getItem("verify_message");
        if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
        localStorage.removeItem("verify_message");
        }
    }

    componentDidMount () {
        if(this.state.loaded === 0) {
            this.setState({loaded: 1}, this.loadData());
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.loaded === 1 && prevState.loaded === 0) {
            this.setState({loaded: 2}, this.loadData());
        }
    }

    loadData () {
        var self = this;
        var header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };
              
        var url = config.get('api') + '/fornecedor/combustivel/localidade/'+self.props.match.params.token;
        fetch(url, { method: 'GET', mode: 'cors', headers: header }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'success') {
                self.setState({
                    id: responseJson.data.main.id,
                    currency_id: responseJson.data.main.currency_id,
                    status: responseJson.data.main.status,
                    status_str: responseJson.data.main.status_str,
                    date_start: responseJson.data.main.validity_start_date_str,
                    date_finish: responseJson.data.main.validity_end_date_str,
                    currencies_select: responseJson.data.currencies_select,
                    fuel_locations: responseJson.data.fuel_supplier_locations,
                    loaded: true,
                });
                self.setState({overlay: {message: '', type: '', status: 'closed'}});
            } else {
                self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
        }).then(() => {
            self.handleMessage();
        });
    }

    edit(event) {
        event.preventDefault();
        this.handleAlert('', '', 'open');
        var datasave = {
            id: this.state.id,
            currency_id: this.state.currency_id,
            value: this.state.value,
        };

        var header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };
    
        var self = this;
        fetch(config.get('api') + '/fornecedor/combustivel/localidade', { method: 'PUT', mode: 'cors', headers: header, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'success') {
            self.setState({ fuel_supplier_locations: responseJson.data });
        } else if(responseJson.data == 'incomplete') {
            self.setState({ loaded: true });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
        console.error(error);
        });
    }
  
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title pull-left">{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.tituloSupplierToken}</h3>
        <div className="clearfix"></div>
        <hr />
        {this.state.loaded === true ?
            <div>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped">
                    <thead>
                        <tr>
                        <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.tabela.Localidade}</th>
                        <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.tabela.InicioDaVigencia}</th>
                        <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.tabela.TerminoDaVigencia}</th>
                        <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.tabela.Moeda}</th>
                        <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.tabela.Valor}</th>
                        </tr>
                    </thead>
                    <tbody id="dates">
                    {Object.keys(self.state.fuel_locations).map(function(k) {
                        var fuel_location = self.state.fuel_locations[k];
                        return (
                        <tr>
                            <td>{fuel_location.location.name}</td>
                            <td>{fuel_location.validity_start_date_str}</td>
                            <td>{fuel_location.validity_end_date_str}</td>
                            <td>{fuel_location.currency ? fuel_location.currency.alphabetical_code : ''}</td>
                            <td>{fuel_location.value_str}</td>
                        </tr>
                        );
                    })}
                    </tbody>
                    </table>
                </div>
                <hr />
                <form onSubmit={this.edit}>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.formulario.Moeda}:</label>
                            <Select
                            className="form-field-name"
                            name="currency_id"
                            value={this.state.currency_id}
                            searchable={true}
                            placeholder={this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.formulario.placeholder.SelecionarMoeda}
                            onChange={this.handleSelectChange.bind(this, 'currency_id')}
                            options={this.state.currencies_select}
                            required
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                            <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.formulario.ValorLitro + this.state.date_start + this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.formulario.Ate + this.state.date_finish}:</label>
                            <input type="text" placeholder={this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.formulario.placeholder.ValorLitro} className="form-control" name="value" value={this.state.value} onChange={this.handleChange.bind(this, 'value')} />
                            </div>
                        </div>
                    </div>    
                    <div>
                        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.EditarLocalidadeToken.formulario.botaoEditarLocalidade}</button>
                    </div>
                </form>
            </div>


        :
        <div className="user-content text-center" style={{paddingTop: '20px', border: 'none'}}>
            <div className="row">
                <div className="col-md-4 col-md-offset-4 text-center">
                <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGVOOS" />
                </div>
            </div>
        </div>
        }



    </div>
  </div>
</div>
    );
  }
}

export default FuelSupplierLocationsEdit;



// WEBPACK FOOTER //
// ./src/Components/FuelSupplierLocations/FuelSupplierLocationsEdit.js